export default { 
    Marker,
    Geocode,
    Location,
    CenterMarkers
}

function Marker(map, options) {

    const marker = new google.maps.Marker({
        map,
        ...options
    })

    marker.events = {}
    marker.infowindow = new google.maps.InfoWindow() 

    marker.setCenter = () => {
        map.setCenter(marker.getPosition())
    }

    marker.setEvent = (name, callback) => {
        marker.events[name] = callback
        return marker
    }

    marker.openWindow = (location, content) => {

        if(!marker.infowindow)
            marker.infowindow = new google.maps.InfoWindow()

        marker.infowindow.setContent(content)
        marker.infowindow.setPosition(location)
        marker.infowindow.open({map, anchor: marker})
    }

    marker.addListener('click', event => {

        if(marker.events.click)
            marker.events.click(event, marker)
    })

    marker.addListener('dragstart', event => {
        if(marker.events.dragstart)
            marker.events.dragstart(event, marker)
    })

    marker.addListener('dragend', async event => {
        if(marker.events.dragend) {

            marker.location = await Geocode({
                location: {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
            })

            marker.events.dragend(event, marker)
        }
    })

    return marker
}

async function Geocode(data) {
    return new Promise((resolve, reject) => {
    
        const geocoder = new google.maps.Geocoder()
    
        geocoder.geocode(data, (results, status) => {
    
            if(status != 'OK')
                return resolve(null)
    
            resolve(Location(results[0]))
        })
    })
}

function Location(place) {

    const location = {
        placeId: place.place_id,
        address: place.formatted_address,
        coordinates: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        },
    }

    place.address_components.forEach(component => {
        switch(component.types[0]) {
            case 'street_number': location.number = component.long_name; break
            case 'route': location.street = component.long_name; break
            case 'sublocality_level_1': location.colony = component.long_name; break
            case 'locality': location.city = component.long_name; break
            case 'administrative_area_level_1': location.state = component.long_name; break
            case 'country': location.country = component.long_name; break
            case 'postal_code': location.zipcode = component.long_name; break
        }
    })

    return location
}

function CenterMarkers(map, markers) {

    const bounds = new google.maps.LatLngBounds()

    markers.forEach(marker => {
        bounds.extend(marker.getPosition())
    })

    map.fitBounds(bounds)
}